// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"83f114dd","567":"860e8e44"}[chunkId] + ".chunk.css";
};